import { addBreadcrumb } from '@sentry/core';
import { Severity } from '@sentry/types';
import { useEffect, useState } from 'react';

import { readCookie } from 'src/utils/Cookies';
import { getField, isEntry } from 'src/utils/EntryUtil';
import { Environment } from 'src/utils/Environment';

import { useSalesChannel } from '../SalesChannel/SalesChannel';

export interface DetailedPromotion {
  readonly promotionName: string;
  readonly promoCode: string;
  readonly promotionDescription: string;
  readonly promotionLongDescription: string;
  readonly startDate: string;
  readonly endDate: string;
}

export const useProgramPromotionInternal = () => {
  const api = Environment.current.cosApiClient;
  const { salesChannel } = useSalesChannel();
  const [ programPromotion, setProgramPromotion ] = useState<DetailedPromotion | undefined>();
  const [ isProgramPromoLoading, setIsProgramPromoLoading ] = useState(false);

  useEffect(() => {
    const promotionCode = readCookie('program');
    const resellerId = getField(salesChannel, 'cloverResellerId');
    const requestUrl = `v3/shop/resellers/${resellerId}/promos/${promotionCode}`;

    if (!isEntry(salesChannel) || !promotionCode || !resellerId) return;

    setIsProgramPromoLoading(true);

    api.get<DetailedPromotion>(requestUrl).then(response => {
      setProgramPromotion(response.data);
      setIsProgramPromoLoading(false);
    }).catch(e => {
      setIsProgramPromoLoading(false);
      addBreadcrumb({
        message: 'Error Fetching Program Promotion',
        data: {
          reseller: resellerId,
          promoCode: promotionCode,
        },
        category: 'promotions',
        level: Severity.Info,
      });
    });
  }, [ salesChannel ]);

  return { programPromotion, isProgramPromoLoading };
};
